<template>
    <ul class="portfolio">

<!-- ///////////////////// -->

        <project-internal
            link="zissel"
            background="#94825a"
            tiles="half"
        />

        <project-internal
            link="droplet"
            background="linear-gradient(45deg, #43b9c6, #7b99d6)"
            tiles="half"
        />

<!-- ///////////////////// -->

        <project-internal
            link="digital-data-collection"
            logoSuffix="svg"
            background="linear-gradient(45deg, #381b20, #ffbc97)"
            tiles="full"
        />

<!-- ///////////////////// -->

        <project-internal
            link="maria-jose-moreno"
            background="#b8b8b8"
            tiles="longer"
        />

        <project-external
            title="Dynamic Polyfill Module"
            logoSuffix="svg"
            link="https://www.npmjs.com/package/dynamic-polyfill"
            background="#CB3837"
            tiles="shorter"
        />

<!-- ///////////////////// -->

        <project-internal
            link="robots-and-ai"
            background="#f5f3f4"
            tiles="shorter"
        />

        <project-internal
            link="berlinfuchs"
            background="linear-gradient(45deg, #6bd8c6, #ff9a8c)"
            tiles="longer"
        />

    </ul>
</template>


<script>
import ProjectInternal from './partials/project-internal.vue'
import ProjectExternal from './partials/project-external.vue'

export default {

    components: { ProjectInternal, ProjectExternal }

}
</script>



// WEBPACK FOOTER //
// PortfolioWeb.vue?594dbc75